module.exports = __webpack_public_path__ + "img/max-file-content-image-subtract.eaf69155.svg";